<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <footer class="bg-pb z-index-0 topshad">
    <div class="max-w-7xl mx-auto py-6 px-4 overflow-hidden sm:px-6 lg:px-8">
      <nav
        class="-mx-5 -my-2 flex flex-wrap justify-center z-index-0"
        aria-label="Footer"
      >
        <div class="px-5 py-2">
          <router-link to="/" class="rl text-base text-white hover:text-sg"
            >Home</router-link
          >
        </div>
        <div class="px-5 py-2">
          <router-link to="/menu" class="rl text-base text-white hover:text-sg"
            >Menu</router-link
          >
        </div>
        <div class="px-5 py-2">
          <router-link
            to="/brunch"
            class="rl text-base text-white hover:text-sg"
            >Brunch</router-link
          >
        </div>

        <div class="px-5 py-2">
          <router-link
            to="/dinner"
            class="rl text-base text-white hover:text-sg"
            >Dinner</router-link
          >
        </div>
        <div class="px-5 py-2">
          <button
            @click="openBookingModal"
            class="rl text-base text-white hover:text-sg"
          >
            Book a Table
          </button>
        </div>
        <div class="px-5 py-2">
          <a href="/takeaway" class="rl text-base text-white hover:text-sg">
            Take Away
          </a>
        </div>
        <div class="px-5 py-2">
          <router-link
            to="/contact"
            class="rl text-base text-white hover:text-sg"
            >Contact</router-link
          >
        </div>
        <div class="px-5 py-2">
          <a
            href="https://www.instagram.com/onesquaredbayside/"
            target="_blank"
            class="rl text-base text-white hover:text-sg"
            >Instagram</a
          >
        </div>
      </nav>

      <div class="mt-5 flex justify-center space-x-6">
        <Socials />
      </div>
      <!-- ---- -->

      <p class="mt-4 text-center text-base text-white hover:text-sg">
        <a
          href="https://y-squared.com/"
          target="_blank"
          rel="noopener noreferrer"
          >Designed & created by Y-Squared</a
        >
      </p>
    </div>
  </footer>
</template>

<script setup>
import Socials from "../Other/Socials.vue";
import { openTableEventBus } from "@/utils/eventBus";

// Trigger the global OpenTable modal
const openBookingModal = () => {
  openTableEventBus.emit("open");
};
</script>

<style scoped>
.topshad {
  box-shadow: 0px -2px 2px 1px rgba(0, 0, 0, 0.076);
}
</style>
